import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'achoo-infinite-scroll',
  templateUrl: './achoo-infinite-scroll.component.html',
  styleUrls: ['./achoo-infinite-scroll.component.scss']
})
export class AchooInfiniteScrollComponent {

  @Input()
  public scrollDistance: number;
  @Input()
  public scrollDistanceUp: number;
  @Input()
  public infiniteScrollThrottle: number;
  @Input()
  public infiniteScrollContainer: string | null;
  @Input()
  public scrollWindow = true;
  @Input()
  public fromRoot = false;

  @Output()
  public scrollDownEvent = new EventEmitter<any>();

  @Output()
  public scrollUpEvent = new EventEmitter<any>();


  onScrollDown() {
    this.scrollDownEvent.emit();
  }

  onScrollUp() {
    this.scrollUpEvent.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-infinite-scroll/achoo-infinite-scroll.component.ts